import videojs from 'video.js'; // v5 needed for vimeo plugin
import { DomHelper } from '../general/utils';

class Video {

  static init() {
    let videos = document.getElementsByClassName('video-wrapper');

    for(let video of Array.from(videos)) {
      Video.initVideoJs(video)
    }
  }

  static initVideoJs(wrapper) {
    let type = wrapper.getAttribute('data-type');

    if(DomHelper.elementInViewport(wrapper)) {
      if(type === 'youtube') {

        if(window.ytallowed) {
          Video.initYoutube(wrapper)
        }
      } else if(type === 'vimeo') {

        if(window.vimallowed) {
          Video.initVimeo(wrapper)
        }
      } else {
        if(wrapper.getElementsByClassName('video')[0].getAttribute('data-video-type') === 'mp4') {
          Video.initMP4(wrapper);
        }
        if(wrapper.getElementsByClassName('video')[0].getAttribute('data-video-type') === 'm3u8') {
          Video.initM3u8(wrapper);
        }
      }
    } else {
      Video.pauseVideo(wrapper);
    }
  }

  static initMP4 (wrapper) {
    let video = wrapper.getElementsByClassName('video')[0],
        player = wrapper.getElementsByTagName('video')[0],
        el = null;

    if(wrapper.getAttribute('data-init') !== '1') {
      el = videojs(player, {
        controls: true,
        playsinline: true,
        poster: video.getAttribute('data-poster'),
        controlBar: { pictureInPictureToggle: false },
        sources: [ {
          src: video.getAttribute('data-src'),
          type: 'video/mp4'
        }]
      });

      // set label below play button
      el.bigPlayButton.controlText(video.getAttribute('data-play'));

      wrapper.setAttribute('data-init', '1');
    }
  }

  static initM3u8 (wrapper) {
    let video = wrapper.getElementsByClassName('video')[0],
        player = wrapper.getElementsByTagName('video')[0],
        volumeButtons = wrapper.getElementsByClassName('volume'),
        playButtons = wrapper.getElementsByClassName('play-fallback'),
        el = null;

    video.setAttribute('data-orientation', document.documentElement.getAttribute('data-orientation'));

    if(wrapper.getAttribute('data-init') !== '1') {
      el = videojs(player, {
        html5: {
          vhs: {
            overrideNative: true,
            enableLowInitialPlaylist: true,
            limitRenditionByPlayerDimensions: false
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        muted: true,
        playsinline: true,
        preload: 'none',
        sourceOrder: true,
        language: document.documentElement.lang,
        controls: false,
        poster: Video.getViewportPosterForStage(wrapper, video),
        sources: [{
          src: Video.getViewportSrcForStage(wrapper, video),
          type: 'application/x-mpegURL'
        },{
          src: Video.getViewportSrcForStage(wrapper, video).replace('.m3u8', '.mp4'),
          type: 'video/mp4'
        }]
      });

      wrapper.setAttribute('data-init', '1');

      if(video.getAttribute('data-autoplay')) {
        el.ready(function () {
          for(let volume of Array.from(volumeButtons)) {
            Video.initVolumeButton(volume, el);
          }

          el.play().catch((err) => {
            console.log(err);
            for(let play of Array.from(playButtons)) {
              Video.initPlayFallback(play, el);
            }

            el.pause();
          });

          // -> firefox needs kind of user interaction
          // might be gone with next firefox update
          if(navigator.userAgent.search("Firefox") > -1 && video.getAttribute('data-firefox-fix') !== '1') {
            setTimeout(function () {
              if(el.el().classList.contains('vjs-paused') || el.paused()) {
                window.scrollTo(window.scrollX, window.scrollY - 1);
                window.scrollTo(window.scrollX, window.scrollY + 1);
                video.setAttribute('data-firefox-fix', '1');
              }
            }, 1000);
          }
        });

        // loop
        el.on('ended', function () {

          // check if whole video has ended (not only one part)
          if(el.currentTime() >= el.duration()) {

            // loop without jiggle
            el.currentTime(0);

            el.play().catch((err) => {
              console.log(err);
              for(let play of Array.from(playButtons)) {
                Video.initPlayFallback(play, el);
              }
              el.pause();
            });
          }
        });
      }
    } else {

      if(video.getAttribute('data-autoplay')) {
        Video.playVideo(wrapper);
      }
    }
  }

  static onM3u8Resize () {
    let wrappers = document.getElementsByClassName('video-wrapper');

    for(let wrapper of Array.from(wrappers)) {
      let video = wrapper.getElementsByClassName('video')[0],
          player = videojs.getPlayer(wrapper.getAttribute('data-video')),
          playerDOM = '<video id="' + wrapper.getAttribute('data-video') + '"' + 'class="video-js"><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p></video>'

      if((video.getAttribute('data-video-type') === 'm3u8') && DomHelper.elementExists(player) && wrapper.getAttribute('data-portrait') === '1' && (document.documentElement.getAttribute('data-orientation') !== video.getAttribute('data-orientation'))) {
        // need to dispose player for hls video src change
        Video.pauseVideo(wrapper);
        player.dispose();

        wrapper.setAttribute('data-init', '0');
        video.innerHTML = playerDOM;

        Video.initM3u8(wrapper);
      }
    }
  }

  static getViewportSrcForStage(wrapper, video) {
    if(wrapper.getAttribute('data-portrait') === '1') {
      if(document.documentElement.getAttribute('data-orientation') === 'landscape') {
        return video.getAttribute('data-src');
      } else {
        return video.getAttribute('data-portrait-src');
      }
    } else {
      return video.getAttribute('data-src');
    }
  }
  
  static getViewportPosterForStage(wrapper, video) {
    if(wrapper.getAttribute('data-portrait') === '1') {
      if(document.documentElement.getAttribute('data-orientation') === 'landscape') {
        return video.getAttribute('data-src');
      } else {
        return video.getAttribute('data-portrait-poster');
      }
    } else {
      return video.getAttribute('data-poster');
    }
  }
  static initPlayFallback (play, el) {
    play.classList.remove('hidden');

    if(play.getAttribute('data-init') != '1') {
      play.addEventListener('click', function () {
        el.play();
        play.classList.add('hidden');
      });

      play.setAttribute('data-init', '1');
    }
  }

  static initVolumeButton (volumeButton, el) {
    if(el.audioTracks() && !el.controls()) {
      volumeButton.classList.remove('hidden');
    }

    volumeButton.addEventListener('click', function () {
      if(el.muted()) {
        el.muted(false);
        volumeButton.classList.remove('muted');
      } else {
        el.muted(true);
        volumeButton.classList.add('muted');
      }
    });
  }

  static initYoutube (wrapper) {
    let video = wrapper.getElementsByClassName('video')[0],
        player = wrapper.getElementsByTagName('video')[0],
        el = null;

    if(wrapper.getAttribute('data-init') !== '1') {
      // remove usercentrics on init
      video.removeChild(wrapper.getElementsByClassName('usercentrics-cookie-banner')[0]);

      require('videojs-youtube/dist/Youtube.min');

      el = videojs(player, {
        techOrder: ['youtube'],
        controls: true,
        playsinline: true,
        controlBar: { pictureInPictureToggle: false },
        youtube: {
          enablePrivacyEnhancedMode: true
        },
        poster: Video.getYoutubePoster(Video.getYoutubeID(video.getAttribute('data-src'))),
        sources: [{
          src:  video.getAttribute('data-src'),
          type: 'video/youtube'
        }]
      });

      // set label below play button
      el.bigPlayButton.controlText(video.getAttribute('data-play'));

      wrapper.setAttribute('data-init', '1');
    }
  }

  static getYoutubePoster(id) {
    return 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
  }

  static getYoutubeID (url) {
    let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
      match = url.match(regExp);
    return (match && match[7].length==11)? match[7] : false;
  }

  static initVimeo(wrapper) {
    let video = wrapper.getElementsByClassName('video')[0],
        player = wrapper.getElementsByTagName('video')[0],
        el = null;

    if(wrapper.getAttribute('data-init') !== '1') {
      // remove usercentrics on init
      video.removeChild(wrapper.getElementsByClassName('usercentrics-cookie-banner')[0]);

      // define window object for vimeo plugin
      window.videojs = videojs;
      require('../libs/videojs-vimeo.js');

      el = videojs(player.getAttribute('id'), {
        techOrder: ['vimeo'],
        controls: true,
        playsinline: true,
        controlBar: { pictureInPictureToggle: false },
        poster: Video.getVimeoPoster(Video.getVimeoID(video.getAttribute('data-src'))),
        sources: [ {
          src: video.getAttribute('data-src'),
          type: 'video/vimeo'
        }],
        vimeo: {
          color: '#34CCE4'
        }
      });

      // set label below play button
      el.bigPlayButton.controlText(video.getAttribute('data-play'));

      wrapper.setAttribute('data-init', '1');
    }
  }

  static getVimeoPoster(id) {
    fetch('https://vimeo.com/api/v2/video/' + id + '.json')
      .then(res => res.json())
      .then(data => {
        return data.length ? data[0].thumbnail_large : null
      })
      .catch(err => console.log(err));
  }

  static getVimeoID (url) {
    let match = url.match(/https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/);
    return match ? match[2] : null;
  }

  static pauseVideo (wrapper) {
    let video = videojs.getPlayer(wrapper.getAttribute('data-video'));

    if(DomHelper.elementExists(video)) {
      // video is initialized
      if(!video.paused()) {
        // video is playing and not in viewport
        video.pause();
      }
    }
  }

  static playVideo (wrapper) {
    let video = videojs.getPlayer(wrapper.getAttribute('data-video'));

    if(DomHelper.elementExists(video)) {
      // video is initialized
      if(video.paused()) {
        video.play();
      }
    }
  }
}

export {
  Video
}